import { IssuedTicket } from './IssuedTicket';

export class AgencyTicketReservation {
  invoiceUuid: string;
  reservationIssuedDrives: IssuedTicket[];

  constructor(agencyTicketReservationPlain: any) {
    if (agencyTicketReservationPlain) {
      this.invoiceUuid = agencyTicketReservationPlain.invoiceUuid;
      this.reservationIssuedDrives = agencyTicketReservationPlain
        .reservationIssuedDrives
        .map(divePlain => new IssuedTicket(divePlain));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/AgencyTicketReservation.ts